var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('download-excel',{attrs:{"data":_vm.dados,"fields":_vm.excel.fields,"name":_vm.excel.name}},[_c('v-btn',{attrs:{"title":"Baixar tabela","icon":"","color":"blue lighten-3"}},[_c('v-icon',[_vm._v("fal fa-cloud-download")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }